const URLRewriteSvg = ({
  height = 22,
  width = 22,
  viewBox = '0 0 17 17',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M1 8.5H5.16667M1 8.5C1 12.6421 4.35786 16 8.5 16M1 8.5C1 4.35786 4.35786 1 8.5 1M5.16667 8.5H11.8333M5.16667 8.5C5.16667 12.6421 6.65905 16 8.5 16M5.16667 8.5C5.16667 4.35786 6.65905 1 8.5 1M11.8333 8.5H16M11.8333 8.5C11.8333 4.35786 10.3409 1 8.5 1M11.8333 8.5C11.8333 12.6421 10.3409 16 8.5 16M16 8.5C16 4.35786 12.6421 1 8.5 1M16 8.5C16 12.6421 12.6421 16 8.5 16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default URLRewriteSvg;
